<template>
  <section id="services">
    <div class="section-head reveal">
      <div class="section-label">{{ m.services.label }}</div>
      <h2>{{ m.services.titleLine1 }}<br><em>{{ m.services.titleLine2 }}</em></h2>
    </div>
    <div class="services-list">
      <div
        v-for="(service, index) in m.services.items"
        :key="index"
        class="service-item reveal"
        :style="serviceDelay(index)"
      >
        <div class="service-icon">
          <svg viewBox="0 0 24 24" v-html="serviceIconPaths[index]"></svg>
        </div>
        <div>
          <h3 class="service-title">{{ service.title }}</h3>
          <p class="service-desc">{{ service.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const { messages: m } = useI18n()

const serviceIconPaths = [
  '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>',
  '<rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
  '<path d="M1 6c0 0 5.5-3 11-3S23 6 23 6"/><path d="M1 10c0 0 5.5-3 11-3S23 10 23 10"/><circle cx="12" cy="14" r="3"/><line x1="12" y1="17" x2="12" y2="21"/>',
  '<path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2"/>',
  '<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>',
  '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>',
  '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.35 2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.56a16 16 0 0 0 6 6l.92-.87a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>',
  '<rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>',
  '<rect x="2" y="2" width="20" height="8" rx="2"/><rect x="2" y="14" width="20" height="8" rx="2"/><line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/>',
  '<polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>',
  '<path d="M1 6l10.5 7L22 6"/><rect x="1" y="4" width="22" height="16" rx="2"/>',
  '<circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>'
]

const serviceDelays = [undefined, '.05s', '.1s', '.05s', '.1s', '.15s', undefined, '.05s', '.1s', undefined, '.05s', '.1s']

const serviceDelay = (index: number) => {
  const delay = serviceDelays[index]
  return delay ? { transitionDelay: delay } : undefined
}
</script>